export const organizationDropdownStyle = {
	wrap: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		cursor: 'pointer',
		maxWidth: '280px',
		minWidth: 0,

		'@media (max-width: 767.98px)': {
			maxWidth: 'none',
		},
	},

	info: {
		maxWidth: '170px',
		width: '100%',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',

		'@media (max-width: 767.98px)': {
			maxWidth: 'none',
		},
	},

	avatar: {
		padding: 0,

		'& img': {
			width: '44px',
			height: '44px',
			borderRadius: '50%',
		},
	},

	email: {
		color: 'var(--neutral-300)',
		display: 'block',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	name: {
		display: 'block',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},

	rotateArrow: {
		transform: 'rotate(180deg)',
	},

	options: {
		width: '220px',

		'& > :nth-of-type(4)': {
			'@media (max-width: 1199.98px)': {
				display: 'none',
			},
		},
		'& > :nth-of-type(5)': {
			'@media (max-width: 1199.98px)': {
				display: 'none',
			},
		},
		'& > :nth-of-type(6)': {
			'@media (max-width: 1199.98px)': {
				display: 'none',
			},
		},
	},

	dropdownIcon: {
		'& svg': {
			width: '16px',
			height: '16px',
		},
	},

	option: {
		padding: '8px 16px',
		cursor: 'pointer',

		'&:hover': {
			background: 'var(--background-grey-op-50-1)',
		},

		'&:nth-of-type(7)': {
			borderTop: '1px solid var(--neutral-100)',
			color: 'var(--error-500)',
		},

		'&:last-child': {
			borderTop: '1px solid var(--neutral-100)',
			color: 'var(--error-500)',
		},
	},
};
